import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  private readonly http = inject(HttpClient);

  uploadFile(file: File, type: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    return this.http.post(`${environment.api}/storageFiles/upload`, formData);
  }

  getFile(fileId: string) {
    return this.http.get(`${environment.api}/storageFiles/download/contracts/${fileId}`);
  }

  downloadFile(personId: string) {
    return this.http.get(
      `${environment.api}/storageFiles/download/contracts/${personId}/main`,
      {
        observe: 'response',
        responseType: 'blob',
      }
    );
  }

  downloadFileNoSpinner(personId: string) {
    return this.http.get(
      `${environment.api}/storageFiles/download/contracts/${personId}/main`,
      {
        observe: 'response',
        responseType: 'blob',
        headers: new HttpHeaders().set('x-skip-loading', 'true')
      }
    );
  }
}
